import React from 'react';
import { useSelector } from "react-redux";
import NewHeader from '../Header/NewHeader';
import Footer from '../Footer';

const CheckIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ minWidth: '20px', marginRight: '10px', marginTop: '5px' }}>
        <circle cx="12" cy="12" r="10" fill="#FF5722" />
        <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const NewSubscription = () => {

    const user = useSelector((state) => state.serviceProvider.serviceProvider);

    const plans = [
        {
            id: 1,
            title: "Free No Login",
            borderColor: "#1a67a3",
            features: [
                { text: "Multilingual: English, Spanish, Chinese, Arabic, Hindi, French, Italian, German, Portuguese, Japanese, Korean, Indonasian, Bengali, and others." },
                { text: "Starting knowledge frameworks included: Work Breakdown Structure (WBS), and Feasibility ONLY" },
                { text: "General non-specialized AI Agents with simple request capabilities" },
                { text: "Equivalent to entry level beginner Construction Manager CM/PM/OR with 1 year of experience." },
                { text: "Uses Haiku 4.5 LLM: Lowest trained model" },
                { text: "Extended Thinking Capabilities: Not Available" },
                { text: "File Upload or Analysis: Not Available" },
                { text: "Floor plans RAG Database: Not Available" },
                { text: "Analysis Capabilities: Low" },
                { text: "Chat history / context: Refresh - Auto deletes after 30 minutes." },
                { text: "Reasoning capabilities: Lowest on knowledge benchmarks. Basic queries, Single task handling, Basic pattern matching, simple data retrieval, limited adaptability, foundational understanding." },
                { text: "Good for: Real-time chats, simple data monitoring, basic content generation." }
            ]
        },
        {
            id: 2,
            title: "Free with Login",
            borderColor: "#1a67a3",
            features: [
                { text: "Multilingual: English, Spanish, Chinese, Arabic, Hindi, French, Italian, German, Portuguese, Japanese, Korean, Indonasian, Bengali, and others." },
                { text: "Foundational knowledge frameworks included: WBS, Feasibility, + Planning/Design/Preconstruction" },
                { text: "Additional general AI Agents to support Planning/Design/Preconstruction" },
                { text: "Equivalent to entry level-advanced beginner Construction Manager CM/PM/OR with 3 years of experience." },
                { text: "Uses Haiku 4.5 LLM: Lowest capacity model" },
                { text: "Extended Thinking Capabilities: Not Available" },
                { text: "File Upload or Analysis: Not Available" },
                { text: "Floor plans RAG Database: Not Available" },
                { text: "Analysis Capabilities: Low" },
                { text: "Chat history / context: Available for 10 days then auto-deletes, requires upgrade to save chat history." },
                { text: "Reasoning capabilities: Lowest on knowledge benchmarks. Basic queries, Single task handling, Basic pattern matching, simple data retrieval, limited adaptability, foundational understanding." },
                { text: "Good for: Real-time chats, simple data monitoring, basic content generation." }
            ]
        },
        {
            id: 3,
            title: "Basic ($45/Mo.)",
            borderColor: "#fcc75c",
            features: [
                { text: "Multilingual: English, Spanish, Chinese, Arabic, Hindi, French, Italian, German, Portuguese, Japanese, Korean, Indonasian, Bengali, and others." },
                { text: "Substantial impact knowledge frameworks included: WBS, Feasibility, Planning/Design/Preconstruction, + Construction Cost and Schedule controls, Procurements, Monitoring, Commissioning. + Close Out Transitioning, Post-Occupancy Performance & Warranty Management. + Additional Pre-trained specialists" },
                { text: "Additional general AI Agents to support all framework and specialization tasks" },
                { text: "Equivalent to mid-level intermediate Construction Manager CM/PM/OR with 7 years of experience." },
                { text: "Uses Sonnet 3.7 LLM: Advanced trained model" },
                { text: "Extended Thinking Capabilities: YES" },
                { text: "File Upload or Analysis: YES" },
                { text: "Floor plans RAG Database: ADON Feature", badge: "Add-On" },
                { text: "Analysis Capabilities: Small-Mid Size Databases" },
                { text: "Auto-save included (Chat information always available)" },
                { text: "Reasoning capabilities: Strong multimodal understanding. Competent request with complex hybrid reasoning tasks, Medium document comprehension and multi-step analysis capabilities" },
                { text: "Good for: General business use, content production, data analysis, multimodal understanding" }
            ]
        }
    ];

    const handlePlanSelect = (planName) => {
        console.log(`Evento click: El usuario seleccionó el plan "${planName}"`);
    };

    return (
        <div>
            <NewHeader serviceProvider={user} />
            <div className="container py-5">
                <div className="text-center mb-5">
                    <h1 className="font-weight-bold display-4">Construction Experts in Your Pocket</h1>
                    <h2 className="text-muted font-weight-light">Choose the intelligence level you need</h2>
                </div>

                {/* Grid con igual altura */}
                <div className="row row-cols-1 row-cols-lg-3 align-items-stretch">
                    {plans.map((plan) => (
                        <div key={plan.id} className="col mb-4">
                            <div
                                className="card h-100 shadow-sm border-0"
                                style={{
                                    borderRadius: '15px',
                                    overflow: 'hidden',
                                    borderTop: `8px solid ${plan.borderColor}`
                                }}
                            >
                                <div className="card-body d-flex flex-column p-4" style={{ borderTop: `10px solid ${plan.borderColor}` }}>
                                    <h3 className="card-title font-weight-bold mb-4 text-center">{plan.title}</h3>
                                    
                                    {/* Lista de características que se expande */}
                                    <ul className="list-unstyled flex-grow-1 mb-4">
                                        {plan.features.map((feature, index) => (
                                            <li key={index} className="mb-3 d-flex align-items-start">
                                                <CheckIcon />
                                                <span className="text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
                                                    {feature.badge && (
                                                        <span
                                                            className="badge badge-pill mr-2"
                                                            style={{
                                                                color: '#FF5722',
                                                                border: '1px solid #FF5722',
                                                                backgroundColor: 'transparent',
                                                                fontWeight: 'normal',
                                                                fontSize: '0.75rem',
                                                                verticalAlign: 'middle'
                                                            }}
                                                        >
                                                            {feature.badge}
                                                        </span>
                                                    )}
                                                    {feature.text}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>

                                    <button
                                        className={`btn btn-block py-2 mt-auto ${plan.title.includes('Basic') ? 'btn-warning text-white' : 'btn-dark'}`}
                                        style={{ 
                                            borderRadius: '50px', 
                                            fontWeight: 'bold',
                                            backgroundColor: plan.title.includes('Basic') ? '#fcc75c' : '#343a40',
                                            borderColor: plan.title.includes('Basic') ? '#fcc75c' : '#343a40',
                                            color: plan.title.includes('Basic') ? '#212529' : '#fff'
                                        }}
                                        onClick={() => handlePlanSelect(plan.title)}
                                    >
                                        {plan.title.includes('Free') ? 'Start Now' : 'Upgrade to Basic'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default NewSubscription;